module.exports = __webpack_public_path__ + "static/media/nobilis.7ea9faa4.jpg";